import type { AppCopy } from '../catalogs';

export const gaAppCopy = {
  welcomeHeading: 'Conas is féidir liom cabhrú leat inniu?',
  thinking: 'Ag smaoineamh',
  scrollToBottom: 'Scrollaigh go bun',
  reasoning: 'Réasúnaíocht',
  reasoningInProgress: 'ar siúl',
  citationPages: 'Leathanaigh {first}–{last}',
  citationTitle: 'Sliocht ón bhfoinse',
  citationLoading: 'An fhoinse á lódáil…',
  citationUnavailable: 'Níl an téacs luaite ar fáil nó níl rochtain agat air a thuilleadh.',
  citationOpen: 'Oscail an fhoinse',
  citationCopied: 'Tagairt cóipeáilte',
  copy: 'Cóip',
  more: 'Tuilleadh',
  tryAgain: 'Bain triail eile as',
  answerTruncated: 'Shroich an freagra an teorainn faid agus gearradh é.',
  continueAnswer: 'Lean leis an bhfreagra',
  exportMarkdown: 'Easpórtáil mar Markdown',
  edit: 'Cuir in eagar',
  cancel: 'Cealaigh',
  update: 'Nuashonrú',
  previous: 'Roimhe Seo',
  next: 'Ar aghaidh',
  messagePlaceholder: 'Seol teachtaireacht…',
  projectHomePlaceholder: 'Comhrá nua: {project}',
  sharedChatEveryone: 'Is féidir le gach duine in {company} an comhrá seo a léamh',
  sharedChatOnePerson: 'Is féidir le duine amháin an comhrá seo a léamh',
  sharedChatPeople: 'Líon na ndaoine ar féidir leo an comhrá seo a léamh: {count}',
  forkedChatPlaceholder: 'Lean ar aghaidh le do naisc féin…',
  newAnswer: 'Freagra nua',
  messageInput: 'Ionchur teachtaireachta',
  sendMessage: 'Seol teachtaireacht',
  stopGenerating: 'Stop a ghiniúint',
  addAttachment: 'Cuir ceangaltán leis',
  removeFile: 'Bain an comhad',
  attachmentPreview: 'Réamhamharc ar an gceangaltán',
  imageAttachmentPreview: 'Réamhamharc ar an gceangaltán íomhá',
  image: 'Íomhá',
  openLink: 'nasc oscailte',
  document: 'Doiciméad',
  file: 'Comhad',
  attachment: 'ceangaltán',
  uploadFailed: 'Theip ar an uaslódáil',
  uploading: 'ag uaslódáil',
  toolIncomplete: 'Neamhiomlán',
  toolActivity: 'Gníomhaíocht',
  activityThinking: 'Ag smaoineamh…',
  activityWriting: 'Ag scríobh…',
  activityWaiting: 'Ag fanacht le do cheadú',
  activityStopped: 'Stoptha',
  activityCouldNotFinish: 'Níorbh fhéidir críochnú',
  activitySources: 'foinsí',
  activityShowThinking: 'Taispeáin an smaoineamh',
  activityOpen: 'Oscail gníomhaíocht',
  activitySteps: 'Céimeanna',
  activitySourcesTab: 'Foinsí',
  activityUnavailable: 'Níl an ghníomhaíocht seo ar fáil.',
  activityInput: 'Ionchur',
  activityOutput: 'Aschur',
  activityNoSources: 'Níor luaigh an freagra seo foinsí.',
  activityApprovedByReply: 'Ceadaithe le do fhreagra',

  toolRunning: 'Ag obair',
  toolComplete: 'Críochnaithe',
  toolNeedsApproval: 'Ceadú de dhíth',
  toolInput: 'Ionchur',
  toolCall: 'glao uirlis',
  toolCalls: 'glaonna uirlis',
  openMenu: 'Roghchlár a oscailt',
  closeMenu: 'Dún an roghchlár',
  close: 'Dún',
  showInTextField: 'Taispeáin sa réimse téacs',
  settings: 'Socruithe',
  appearance: 'Cuma',
  themeLight: 'Geal',
  themeDark: 'Dorcha',
  themeSystem: 'Córas',
  themeChoiceHelp:
    'Bíonn feidhm aige ar do ghléasanna go léir. Leanann Córas mód geal nó dorcha gach gléis.',
  themeSaveFailed:
    'Níorbh fhéidir an chuma a shábháil, mar sin níl sí athraithe. Bain triail eile as.',
  toolUsed: 'Uirlis a úsáidtear',
  toolCancelled: 'Uirlis chealaithe',
  toolResult: 'Toradh:',
  toolError: 'Earráid:',
  toolCancelledReason: 'Cúis cealaithe:',
  approvalAllow: 'Ceadaigh',
  approvalAlwaysAllow: 'Ceadaigh i gcónaí',
  approvalDeny: 'Diúltaigh',
  approvalAlwaysDeny: 'Diúltaigh i gcónaí',
  approvalConfirm: 'Deimhnigh',
  approvalBack: 'Ar ais',
  approvalApprovedResult: 'Faofa ag an úsáideoir',
  approvalDeniedResult: "Dhiúltaigh an t-úsáideoir d'fheidhmiú na huirlise",
  logout: 'Logáil amach',
  loginOrCreateAccount: 'Logáil isteach / Cruthaigh cuntas',
  newChat: 'Comhrá nua',
  untitledChat: 'Comhrá gan teideal',
  previousChats: 'Comhráite roimhe seo',
  openChat: 'Oscail an comhrá {title}',
  moreActionsForChat: 'Tuilleadh gníomhaíochtaí le haghaidh {title}',
  chatActions: 'Gníomhartha comhrá',
  closeChatActions: 'Dún gníomhartha comhrá',
  deleteChatQuestion: 'An bhfuil fonn ort an comhrá a scriosadh?',
  deleteChatDescription: 'Scriosfar an comhrá “{title}” go buan.',
  deleteChat: 'Scrios comhrá',
  keepChat: 'Coinnigh an comhrá',
  delete: 'Scrios',
  deleting: 'Ag scriosadh…',
  chatDeleteFailed: 'Níorbh fhéidir an comhrá a scriosadh. Bain triail eile as.',
  settingsDescription: 'Saincheap conas a oibríonn an cúntóir duit.',
  settingsDesktopDescription: 'Saincheap an chaoi a bhfreagraíonn an cúntóir duit.',
  personalization: 'Pearsanú',
  personalizationDescription: 'Saincheap na treoracha a leanann an cúntóir i ngach freagra.',
  languageAndRegion: 'Teanga agus réigiún',
  languageAndRegionDescription: 'Roghnaigh teanga agus crios ama.',
  memories: 'Cuimhní cinn',
  memoriesDescription: 'Féach ar, cuir in eagar nó scrios an rud is cuimhin leis an gcúntóir fút.',
  account: 'Cuntas',
  accountDescription: 'Bainistigh an cuntas agus buanscriosadh do shonraí.',
  backToSettings: 'Ar ais go socruithe',
  closeSettings: 'Dún socruithe',
  settingsCategories: 'Catagóirí socruithe',
  yourSettings: 'Do shocruithe',
  dataAndAccount: 'Sonraí agus cuntas',
  viewAndManageMemories: 'Féach ar agus bainistigh an rud is cuimhin leis an gcúntóir',
  loginToUseMemories: 'Logáil isteach chun cuimhní cinn a úsáid',
  manageOrDeleteAccount: 'Bainistigh nó scrios an cuntas',
  unsavedChanges: 'Tá athruithe gan sábháil agat',
  unsavedCloseDescription: 'Scriosfaidh socruithe deiridh na hathruithe ar an leathanach seo.',
  unsavedBackDescription: 'Má théann tú ar ais, scriosfar na hathruithe ar an leathanach seo.',
  continueEditing: 'Lean ar aghaidh leis an eagarthóireacht',
  discardChanges: 'Scrios na hathruithe',
  saveChanges: 'Sábháil athruithe',
  localSettingsNote: 'Sábháilte sa bhrabhsálaí seo. Logáil isteach chun a shábháil ar do chuntas.',
  personality: 'Pearsantacht',
  personalityHelp: 'Treoracha saincheaptha a leanann an cúntóir i ngach freagra',
  personalityPlaceholder:
    'Mar shampla: Bí gonta agus coincréit. Tá cónaí orm i Gothenburg agus is maith liom bia vegetarian.',
  timezone: 'Crios ama',
  searchTimezone: 'Criosanna ama cuardaigh…',
  automaticBrowser: 'Uathoibríoch (brabhsálaí)',
  saved: 'Sábháilte {date}',
  addMemory: 'Cuir cuimhne leis',
  newMemory: 'Cuimhne nua',
  memoryPlaceholder: 'Mar shampla: Is fearr liom freagraí gearra, nithiúla.',
  editMemory: 'Cuir cuimhne in eagar',
  saveMemory: 'Sábháil cuimhne',
  deleteMemory: 'Scrios cuimhne',
  memorySaveFailed: 'Níorbh fhéidir an chuimhne a shábháil. Bain triail eile as.',
  memoryLimitReached:
    'Is féidir leat suas le 50 cuimhne a shábháil. Scrios ceann amháin sula gcuireann tú ceann eile leis.',
  memoryInvalid: 'Ní féidir naisc a bheith i gcuimhní cinn. Bain an nasc agus bain triail eile as.',
  memoryDeleteFailed: 'Níorbh fhéidir an chuimhne a scriosadh. Bain triail eile as.',
  memoryLoadFailed: 'Níorbh fhéidir cuimhní cinn a lódáil.',
  loadingMemories: 'Cuimhní cinn á lódáil…',
  emptyMemories:
    'Sábhálann an cúntóir cuimhní fút agus tú ag caint - cad is maith leat, áit a bhfuil cónaí ort, agus cad a dhéanann tú. Is féidir leat iad a fheiceáil, a chur in eagar agus a scriosadh anseo.',
  deleteAccountHelp:
    'Scrios go buan an cuntas agus gach comhrá, cuimhní cinn agus socruithe a bhaineann leis.',
  deleteAccount: 'Scrios cuntas',
  deleteAccountQuestion: 'An bhfuil fonn ort an cuntas a scriosadh go buan?',
  deleteAccountDescription:
    'Scriosfar gach comhrá, teachtaireacht, cuimhní cinn, socruithe agus dintiúir síniú isteach. Ní féidir an gníomh seo a chealú.',
  deleteAccountConfirm: 'Sea, scrios mo chuntas',
  accountDeleteFailed:
    'Níorbh fhéidir an cuntas a scriosadh. Níor baineadh tada - bain triail eile as.',
  logoutEverywhereTitle: 'Gach gléas',
  logoutEverywhereHelp:
    'Logáil amach ar gach gléas agus brabhsálaí ina bhfuil do chuntas oscailte, an ceann seo san áireamh.',
  logoutEverywhere: 'Logáil amach i ngach áit',
  logoutEverywhereQuestion: 'Logáil amach ar gach gléas?',
  logoutEverywhereDescription:
    'Beidh ort logáil isteach arís ar gach gléas agus brabhsálaí, an ceann seo san áireamh. Fanfaidh do chomhráite agus do shocruithe mar atá.',
  loggingOut: 'Ag logáil amach…',
  logoutEverywhereFailed:
    'Níorbh fhéidir a dheimhniú gur logáladh amach thú i ngach áit. Bain triail eile as, nó seiceáil ar ghléas eile an bhfuil tú logáilte isteach fós.',
  settingsSaveFailed: 'Níorbh fhéidir na socruithe a shábháil. Bain triail eile as.',
  customInstructions: 'Treoracha saincheaptha',
  notSet: 'Gan socraithe',
  automaticLanguage: 'Teanga uathoibríoch',
  automaticTimezone: 'crios ama uathoibríoch',
  appLanguage: 'Teanga app',
  appLanguageHelp:
    'Rialaíonn sé comhéadan iomlán na haipe agus na dátaí. Leanann freagraí an chúntóra an teanga ina scríobhann tú.',
  automaticBrowserLanguage: 'Uathoibríoch (teanga bhrabhsálaí)',
  previousLanguageChoice: 'Rogha roimhe seo: {language} ({locale})',
  previousLanguageChoiceCode: 'Rogha roimhe seo ({locale})',
  canvasCopyLink: 'Cóipeáil an nasc',
  canvasLinkCopied: 'Cóipeáladh an nasc',
  actionUpdatedWithEdits: 'Nuashonraithe le d’athruithe',
  activityStepsDone:
    'one:chéim déanta|two:chéim déanta|few:chéim déanta|many:gcéim déanta|other:céim déanta',
  activityResultsCount: 'one:toradh|two:thoradh|few:thoradh|many:dtoradh|other:toradh',
  canvasCopyLinkFailed: 'Níorbh fhéidir an nasc a chóipeáil',
  canvasOpenInAgent: 'Oscail san aip {agent}',
  canvasExpand: 'Leathnaigh',
  canvasExitFullView: 'Scoir den lánamharc',
  webSourceUnread:
    'Nasctha sa fhreagra seo. Níor léigh Poneva an leathanach seo, mar sin níl aon rud le taispeáint anseo.',
  webSourceOpenOriginal: 'Oscail an bunleagan',
  toolProgressSettings: 'Do shocruithe á n-athrú…',
  toolProgressAgent: 'An gníomhaire á chruthú…',
  toolProgressConnections: 'Roghanna ceangail á n-aimsiú…',
  toolProgressResult: 'Do thoradh á ullmhú…',
  toolProgressClarification: 'Soiléiriú á ullmhú…',
  toolProgressKnowledge: 'Nuashonrú eolais molta á ullmhú…',
  toolProgressQuestion: 'Ceist á hullmhú duit…',
  toolProgressSkill: 'Do Skill á mhúnlú…',
  toolErrorSettings: 'Níor athraíodh do shocruithe.',
  toolErrorAgent: 'Níorbh fhéidir an gníomhaire a chruthú.',
  toolErrorConnections: 'Níorbh fhéidir roghanna ceangail a lódáil.',
  toolErrorResult: 'Níor sábháladh an toradh.',
  toolErrorClarification: 'Níorbh fhéidir an soiléiriú a ullmhú.',
  toolErrorKnowledge: 'Níorbh fhéidir an nuashonrú eolais molta a ullmhú.',
  toolErrorQuestion: 'Níorbh fhéidir an cheist a ullmhú.',
  toolErrorSkill: 'Níorbh fhéidir dréacht an Skill a shábháil.',
  toolErrorOpenSettings: 'Oscail Socruithe',
  toolErrorOpenAgents: 'Oscail Gníomhairí',
  toolErrorOpenConnections: 'Oscail Ceangail',
  toolStepIncomplete: 'Níor críochnaíodh an chéim seo.',
  toolEarlierAttemptsFailed:
    'one:iarracht roimhe sin nár éirigh léi|two:iarracht roimhe sin nár éirigh leo|few:iarrachtaí roimhe sin nár éirigh leo|many:n-iarracht roimhe sin nár éirigh leo|other:iarracht roimhe sin nár éirigh leo',
} satisfies AppCopy;
